'use strict';

$(function(){
    var searchShown = false;
    var custZoneShown = false;

    var $searchPanel = $('#search_panel');
    var $custZonePanel = $('#customer_zone_panel');
    var $showMenu = $('#mh_nav');
    var $hideMenu = $('#mh_nav_hide');
    var $mhUser = $('.customer-zone-trigger');
    var $mhSearch = $('#mh_search');
    var $tabsMenuItems = $('.two-tabs ul li');
    var $tabContents = $('.two-tabs > div');
    var $customerZoneLink = $('.showCustomerZone');

    $searchPanel.css('display', 'block').hide();

    var addTo = function(target, source){
        for (var attribute in source)
            target[attribute] = source[attribute];
    };

    if (!window.jim) window.jim = {};

    var hideCzOnOutsideClick = function(e){
        if (!$custZonePanel.is(e.target) && $custZonePanel.has(e.target).length === 0
            && $('.toast').has(e.target).length === 0) {
            // We add a slight delay here.  This prevent elements with relative positioning to move right between
            // the mousedown and mouseup parts of a click, causing the user the miss-click certain elements.
            setTimeout(function(){
                jim.hideCustomerZone();
            }, 250);
        }
    };

    addTo(window.jim, {
        showCustomerZone: function(){
            this.hideNavigation();
            custZoneShown = true;
            $('body').addClass('cz-panel-opened');
            $(document).bind('mousedown', hideCzOnOutsideClick);
        },
        hideCustomerZone: function(){
            custZoneShown = false;
            $('body').removeClass('cz-panel-opened');
            $(document).unbind('mousedown', hideCzOnOutsideClick);
        },
        toggleCustomerZone: function(){
            if (custZoneShown)
                window.jim.hideCustomerZone();
            else
                window.jim.showCustomerZone();
        },
        showNavigation: function(){
            this.hideCustomerZone();
            $('body').addClass('nav-panel-opened');
        },
        hideNavigation: function(){
            $('body').removeClass('nav-panel-opened');
        },
        showSearch: function(){
            $searchPanel.slideDown(200, function(){
                $searchPanel.find('input').focus();
            });
            searchShown = true;
        },
        hideSearch: function(){
            $searchPanel.slideUp(200);
            searchShown = false;
        },
        toggleSearch: function(){
            if (searchShown)
                jim.hideSearch();
            else
                jim.showSearch();
        },

        goHome: function(){
            window.location.assign('/');
        }
    });

    $mhSearch.click(function(e){
        jim.toggleSearch();
        e.preventDefault(); return false;
    });

    $mhUser.click(function(e){
        jim.toggleCustomerZone();
        e.preventDefault(); return false;
    });

    $showMenu.click(function(e){
        jim.showNavigation();
        e.preventDefault(); return false;
    });

    $hideMenu.click(function(e){
        jim.hideNavigation();
        e.preventDefault(); return false;
    });

    $custZonePanel.find('.close-button').click(function(e){
        jim.hideCustomerZone();
        e.preventDefault(); return false;
    });

    $customerZoneLink.click(function(e){
        jim.showCustomerZone();
    });

    var $topMenus = $('#customer_zone_panel').find('a.has-children');
    $topMenus.next('ul').hide();
    var closeMenu = function($menu){
        $menu.next('ul').slideUp('100');
        $menu.removeClass('open');
    };
    var openMenu = function($menu){
        $menu.next('ul').slideDown('100');
        $menu.addClass('open');
    };
    $topMenus.mousedown(function(e){
        var $menu = $(this);
        if ($menu.is('.open'))
            closeMenu($menu);
        else {
            closeMenu($topMenus.remove($menu));
            openMenu($menu);
        }
        e.preventDefault(); return false;
    });
    $custZonePanel.find('.cz-navigation a').not('.has-children').mouseup(function(){
        jim.hideCustomerZone();
    });


    // add a class to indicate a wizard step is out of sight
    // this is used to make sure the wizard footer stalks correctly on smaller
    // devices
    $(window, document).scroll(function(){
        $('.wizard-step:visible').each(function(){
            $(this).toggleClass('scrolled-out',
                ($(this).offset().top + $(this).height() + 60) < $(window).scrollTop() + $(window).height());
        });
    });

    // keep hashes in language links in sync
    var adaptLanguageLinkHashes = function(){
        $('span.language-picker > a').each(function(){
            var href = $(this).attr('href');
            href = href.split('#')[0] + window.location.hash;
            $(this).attr('href', href);
        });
    };
    $(window).bind( 'hashchange', adaptLanguageLinkHashes);
    adaptLanguageLinkHashes();

    /**
     * Accordeon - drop down boxes
     */
    $('.drop-down-box h3').click(
        function(){
            $( this ).parent().toggleClass('opened');
            $( this ).parent().children('p').slideToggle();
        }
    );

    /**
     * Tabs management
     */
    $tabsMenuItems.click(function(){
        $tabsMenuItems.toggleClass('active');
        $tabContents.toggleClass('active');
    });

    // toastr config
    toastr.options.closeButton = true;
    toastr.options.newestOnTop = true;
    toastr.options.timeOut = 7200;
    toastr.options.extendedTimeOut = 36000;
    toastr.options.positionClass = 'toast-top-center';

    // if touch happens, assume touch mode.  If mouse event, assume mouse mode
    // see https://stackoverflow.com/a/30303898/396618
    try {
        document.addEventListener('touchstart', function(){ $('body').addClass('touch-mode'); }, true);
        document.addEventListener('mousemove', function(){ $('body').removeClass('touch-mode'); }, true);
    }
    catch (e){
        /* this is not critical. If addEventListener is not supported, then neither is touch mode */
    }
});
